module.exports = __webpack_public_path__ + "img/ccc.374e4f0f.png";